module.exports = __webpack_public_path__ + "static/office-c10e4a237f2986d9501338076b404c27.mp4";